import {css} from 'lit';

export const style = css`

    :host {
        display: block;
    }

    * {
        box-sizing: border-box;
    }

    .alert {
        font: var(--sbkFileUploadTypographyTitle);
        max-width: var(--sbkAlertSizingMaxWidth);
        border-radius: var(--sbkFileUploadBorderRadiusDefault);
        display: flex;
        color: var(--sbkFileUploadColorFgcolorDefault);
        margin: var(--sbkCoreSpacingMd) 0;
    }

    .icon-wrapper {
        display: flex;
        align-items: center;
        background-color: inherit;
    }

    .alert-icon {
        padding: var(--sbkFileUploadSpacingIconAreaInsetTopBottom) var(--sbkFileUploadSpacingIconAreaInstLeftRight);
    }

    .alert-content {
        padding: var(--sbkAlertSpacingStatusAreaInsetTop) var(--sbkAlertSpacingStatusAreaInsetRight) var(--sbkAlertSpacingStatusAreaInsetBottom) var(--sbkAlertSpacingStatusAreaInsetLeft);
    }

    .alert-title {
        font: var(--sbkFileUploadTypographyTitle);
        padding-bottom: var(--sbkFileUploadSpacingStatusAreaGapTitleStatusText);
        font-weight: bold;
    }

    .alert-message {
        display: block;
        margin: var(--sbkAlertSpacingStatusAreaGapTitleStatusText) 0 0;
        font: var(--sbkFileUploadTypographyStatus);
    }

    .alert-error {
        border: var(--sbkAlertBorderError);

        .icon-wrapper,
        .icon-background {
            background-color: var(--sbkFileUploadColorBgColorError);
        }

        .alert-content {
            color: var(--sbkFileUploadColorBgColorError);
        }
    }

    .alert-success {
    border: var(--sbkAlertBorderSuccess);

    .icon-wrapper,
    .icon-background {
      background-color: var(--sbkFileUploadColorBgColorSuccess);
    }

    .alert-content {
      color: var(--sbkFileUploadColorBgColorSuccess);
    }
  }
`;
